<template>
  <div>
    <div class="header" v-if="infoVisible == false">
      <h1 v-on:click="HomePage" v-if="$route.name !== 'administration'">
        Pixel<span>GRID</span>
      </h1>
      <h1 v-else>Pixel<span>GRID</span></h1>
      <button
        class="info"
        @click="openInfo"
        v-if="$route.name !== 'administration'"
      >
        i
      </button>
      <div v-else>
        <div class="admin">
          <button @click="reorderApp()">Reorder GRID</button>
          <button @click="restartApp()">Restart GRID</button>
        </div>
        <!-- <div class="meta">
          Pixels:{{ metadata.pixels }} | Current: {{ metadata.current }}
        </div> -->
      </div>
    </div>

    <infoPage
      class="tutorial"
      v-if="infoVisible == true"
      @changeVisibility="changeInfoVisibility"
    ></infoPage>
  </div>
</template>

<script>
import infoPage from "@/components/information";
import axios from "axios";
export default {
  name: "header-component",
  components: {
    infoPage,
  },
  data() {
    return {
      infoVisible: false,
      metadata: {},
    };
  },

  methods: {
    HomePage() {
      this.$router.push({
        name: "home",
      });
    },
    restartApp() {
      axios.get(`/restart`).then((res) => {
        console.log("metadata", res.data);
        this.metadata = res.data;
        this.$socket.emit("newPixel", true);
      });
    },
    reorderApp() {
      axios.get(`/reordering`).then((res) => {
        console.log(res);

        //this.pixels = res.data;
      });
    },
    changeInfoVisibility() {
      this.infoVisible = false;
    },
    openInfo() {
      this.infoVisible = true;
    },
  },
};
</script>

<style>
.header {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  padding: 25px 0px 15px;
  background-color: #171717e0;
  z-index: 4;
  backdrop-filter: blur(3px);
  text-align: center;
}
.header h1 {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-weight: 600;
  font-size: 40px;
  margin: 0;
  color: white;
}

.header span {
  color: #f7c544;
  font-weight: 900;
}

.header button.info {
  position: absolute;
  right: 10px;
  top: 10px;
  border: 2px solid #d72d20;
  border-radius: 100%;
  font-size: 16px;
  padding: 5px;
}
.header .admin {
  position: absolute;
  right: 30px;
  top: 30px;
}
.header .admin button {
  border: 2px solid #d72d20;
  font-size: 16px;
  padding: 5px 15px;
  margin: 0 10px;
}

.tutorial {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100vw;
  height: 100vh;
}
</style>
